function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }
function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) arr2[i] = arr[i]; return arr2; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }
import { useEffect, useRef, useState } from 'react';
var debounce = function debounce(func, ms) {
  var timeout;
  return function () {
    clearTimeout(timeout);
    timeout = setTimeout(function () {
      timeout = null;
      func();
    }, ms);
  };
};
var hasPreviousItem = function hasPreviousItem(carouselRef) {
  if (carouselRef.current && carouselRef.current.scrollLeft > 0) {
    return true;
  }
  return false;
};
var hasNextItem = function hasNextItem(carouselRef) {
  if (carouselRef.current && carouselRef.current.scrollWidth - carouselRef.current.scrollLeft > carouselRef.current.offsetWidth + 1) {
    return true;
  }
  return false;
};
export var useCarousel = function useCarousel(_ref) {
  var columnGap = _ref.columnGap,
    forceNextItemControlEnabled = _ref.forceNextItemControlEnabled,
    forcePreviousItemControlEnabled = _ref.forcePreviousItemControlEnabled,
    itemCount = _ref.itemCount,
    onNavigateLeft = _ref.onNavigateLeft,
    onNavigateRight = _ref.onNavigateRight;
  var _useState = useState(false),
    _useState2 = _slicedToArray(_useState, 2),
    showPreviousControl = _useState2[0],
    setShowPreviousControl = _useState2[1];
  var _useState3 = useState(false),
    _useState4 = _slicedToArray(_useState3, 2),
    showNextControl = _useState4[0],
    setShowNextControl = _useState4[1];
  var xPosition = useRef(0);
  var carouselRef = useRef(null);
  var columnGapRef = useRef(0);
  var forcePreviousItemControlEnabledRef = useRef();
  var forceNextItemControlEnabledRef = useRef();
  // Track whether carousel navigations were triggered by swipe (default) or controls (set when controls used)
  var isSwipeNavigation = useRef(true);

  // Assign params to refs so the updated values can be accessed in the scroll handler
  useEffect(function () {
    columnGapRef.current = columnGap;
    forcePreviousItemControlEnabledRef.current = forcePreviousItemControlEnabled;
    forceNextItemControlEnabledRef.current = forceNextItemControlEnabled;
  });
  useEffect(function () {
    // Maintain carouselRefValue for cleanup to avoid ref instance error
    var carouselRefValue = carouselRef.current;
    if (carouselRef.current) {
      // Setup controls
      if (hasNextItem(carouselRef) || Boolean(forceNextItemControlEnabledRef.current) === true) {
        setShowNextControl(true);
      }

      // Scroll listener for managing visibility of controls and triggering callbacks
      var handleScroll = debounce(function () {
        if (!carouselRef.current) {
          return;
        }

        // Check whether carousel is at a scroll position or between items (e.g. currently swiping)
        var itemWidth = (carouselRef.current.scrollWidth - columnGapRef.current * (itemCount - 1)) / itemCount;
        var atScrollEndPosition = carouselRef.current.scrollWidth - carouselRef.current.scrollLeft === carouselRef.current.offsetWidth;
        var atNonEndScrollPosition = carouselRef.current.scrollLeft % (itemWidth + columnGapRef.current) === 0;
        var atScrollPosition = atScrollEndPosition || atNonEndScrollPosition;

        /*
          Note - these events will fire on window resize. This could be avoided by wrapping this event listener in a
          setTimeout 0, and setting a flag in a window resize event handler to signal that a resize triggered the
          scroll handler.
          https://stackoverflow.com/questions/45635008/how-can-i-prevent-onscroll-function-to-trigger-during-resize
        */
        // Note: only fire these when swiping, as they have already been fired for control based navigation
        if (isSwipeNavigation.current === true && carouselRef.current.scrollLeft < xPosition.current && atScrollPosition) {
          onNavigateLeft === null || onNavigateLeft === void 0 || onNavigateLeft({
            swiped: true
          });
        } else if (isSwipeNavigation.current === true && carouselRef.current.scrollLeft > xPosition.current && atScrollPosition) {
          onNavigateRight === null || onNavigateRight === void 0 || onNavigateRight({
            swiped: true
          });
        }

        // Once event handlers triggered, reset isSwipe to default
        isSwipeNavigation.current = true;
        xPosition.current = carouselRef.current.scrollLeft;
        if (hasNextItem(carouselRef) || Boolean(forceNextItemControlEnabledRef.current) === true) {
          setShowNextControl(true);
        } else {
          setShowNextControl(false);
        }
        if (hasPreviousItem(carouselRef) || forcePreviousItemControlEnabledRef.current) {
          setShowPreviousControl(true);
        } else {
          setShowPreviousControl(false);
        }
      }, 200);
      carouselRefValue === null || carouselRefValue === void 0 || carouselRefValue.addEventListener('scroll', handleScroll);
      return function () {
        carouselRefValue === null || carouselRefValue === void 0 || carouselRefValue.removeEventListener('scroll', handleScroll);
      };
    }
    return function () {};
    // Note: (Performance) having onNavigateLeft and onNavigateRight causes this hook to run on every re-render
    // (e.g. window resize)
    // To prevent this, the onNavigate function could be wrapped in useCallback - this requires parent carousels to not
    // then wrap this function in another function
  }, [itemCount, onNavigateLeft, onNavigateRight, showNextControl, showPreviousControl]);
  return {
    showPreviousControl,
    showNextControl,
    isSwipeNavigation,
    carouselRef
  };
};

// Encapsulate scrollTo in util for testing purposes as jest dom doesn't support it
export var smoothScrollCarousel = function smoothScrollCarousel(carouselRef, scrollLeft) {
  // Ensure ref exists and that scrollTo exists (it doesn't work in tests and in some instances mocking is tricky)
  // eslint-disable-next-line
  if (carouselRef.current && carouselRef.current.scrollTo) {
    carouselRef.current.scrollTo({
      left: scrollLeft,
      behavior: 'smooth'
    });
  }
};
export var useCarouselControls = function useCarouselControls(_ref2) {
  var carouselRef = _ref2.carouselRef,
    columnGap = _ref2.columnGap,
    isSwipeNavigation = _ref2.isSwipeNavigation,
    itemCount = _ref2.itemCount,
    onNavigateLeft = _ref2.onNavigateLeft,
    onNavigateRight = _ref2.onNavigateRight,
    smoothScrollCarouselDI = _ref2.smoothScrollCarouselDI;
  var columnGapRef = useRef(0);

  // Assign params to refs so the updated values can be accessed in the callbacks
  useEffect(function () {
    columnGapRef.current = columnGap;
  });
  var onPrevious = function onPrevious() {
    if (!carouselRef.current) {
      return;
    }
    isSwipeNavigation.current = false;
    var scrollWidthWithoutColumnGaps = carouselRef.current.scrollWidth - columnGapRef.current * (itemCount - 1);
    var scrollLeft = Math.floor(carouselRef.current.scrollLeft - scrollWidthWithoutColumnGaps / itemCount - columnGapRef.current);

    /*
      Note: scrollLeft is slightly off for first left scroll from right end due to un-uniform scroll position at this
      point. However, it is snapped to position regardless by the browser later, and so downstream functionality works
      correctly.
    */
    smoothScrollCarouselDI(carouselRef, scrollLeft);
    onNavigateLeft === null || onNavigateLeft === void 0 || onNavigateLeft({
      swiped: false
    });
  };
  var onNext = function onNext() {
    if (!carouselRef.current) {
      return;
    }
    isSwipeNavigation.current = false;
    var scrollWidthWithoutColumnGaps = carouselRef.current.scrollWidth - columnGapRef.current * (itemCount - 1);
    var scrollLeft = Math.floor(carouselRef.current.scrollLeft + scrollWidthWithoutColumnGaps / itemCount + columnGapRef.current);
    smoothScrollCarouselDI(carouselRef, scrollLeft);
    onNavigateRight === null || onNavigateRight === void 0 || onNavigateRight({
      swiped: false
    });
  };
  return {
    onPrevious,
    onNext
  };
};